import { ChangeDetectorRef, Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params } from '@angular/router';
import { faCircleCheck, faCircleMinus, faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { MinuteRequestDetailRealTimeDTO, OwnersMinuteRequest } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-detail';
import { UpdateAvalMinute, UpdateRLOwnerMinute } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-request.interface';
import { MinuteRequestService } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/service/minute-request.service';

@Component({
  selector: 'app-minute-owners',
  templateUrl: './minute-owners.component.html',
  styleUrls: ['./minute-owners.component.scss']
})
export class MinuteOwnersComponent implements OnInit, OnChanges {
  @Input() minuteOwnersRequest: OwnersMinuteRequest[] | undefined;
  @Input() minuteRequestRealTime: MinuteRequestDetailRealTimeDTO | undefined;
  @Input() forMinute: boolean = false;

  public listAvalOwners: string[] = [];
  public listRlOwners: string[] = [];
  public idMinute: number = 0;
  public spinner: boolean = false;
  public spinnerRL: boolean = false;
  public dataSourceOwners!: MatTableDataSource<OwnersMinuteRequest>;
  public displayedColumnsOwners: string[] = [
    'aval', 'rl', 'participation', 'nameAndRut', 'age', 'civilState'
  ];

  public icons = { faCircleMinus, faCircleCheck, faCircleXmark };

  constructor(
    private minuteRequestService: MinuteRequestService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    if (this.forMinute) {
      this.displayedColumnsOwners.push('amountVigenteCmf', 'dicom','autos','propiedades');
    }
    this.route.queryParams.subscribe((params: Params) => {
      this.idMinute = +params['id'] || 0;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['minuteOwnersRequest']) {
      this.setDataSource(this.minuteOwnersRequest);
    }
  }

  private setDataSource(dataSource: OwnersMinuteRequest[] | undefined): void {
    this.dataSourceOwners = new MatTableDataSource<OwnersMinuteRequest>(dataSource);
    this.cdr.detectChanges();
  }

  public getReportUrl(rut: string): string {
    const rutFormat = rut.split('.').join('');
    const parametros = `{"Token":"IngeInternalApiKey55","Rut":"${rutFormat}"}`;
    const base64Datos = window.btoa(parametros);
    return `https://scoringreport.inge.cl/api/Equifax/HtmlEncodedReport/${base64Datos}`;
  }

  public showAvalSpinner(fullRut: string): boolean {
    return this.listAvalOwners.includes(fullRut);
  }

  public showRlSpinner(fullRut: string): boolean {
    return this.listRlOwners.includes(fullRut);
  }

  public toggleDebtorResolutionChange(fullRut: string, avalState: boolean): void {
    this.listAvalOwners.push(fullRut);
    const updatedAvalState = !avalState;
    const request: UpdateAvalMinute = {
      aval: updatedAvalState,
      avalOwnerId: fullRut,
      minuteRequestId: this.idMinute
    };

    this.minuteRequestService.updateMinute(request).subscribe({
      complete: () => {
        this.listAvalOwners = this.listAvalOwners.filter(e => e !== fullRut);
        this.cdr.detectChanges();
      }
    });
  }

  public updateRlOwnerMinute(fullRut: string, rlState: boolean): void {
    this.listRlOwners.push(fullRut);
    const rlStateUpdate = !rlState;
    const request: UpdateRLOwnerMinute = {
      rL: rlStateUpdate,
      OwnerId: fullRut,
      minuteRequestId: this.idMinute
    };

    this.minuteRequestService.updateRlOwnerMinute(request).subscribe({
      complete: () => {
        this.listRlOwners = this.listRlOwners.filter(e => e !== fullRut);
        this.cdr.detectChanges();
      }
    });
  }

  public isDisabled(): boolean {
    const resolutionName = this.minuteRequestRealTime?.finalResolutionName;
    return resolutionName === 'Cancelada' || resolutionName === 'Rechazado';
  }

  public handleClick(fullRut: string, aval: boolean): void {
    if (!this.minuteRequestRealTime?.isClosed) {
      this.toggleDebtorResolutionChange(fullRut, aval);
    }
  }

  handleRlClick(fullRut: string, rl: boolean): void {
    if (!this.minuteRequestRealTime?.isClosed) {
      this.updateRlOwnerMinute(fullRut, rl);
    }
  }
  

}

